'use client'

import { type Url } from 'next/dist/shared/lib/router/router'
import Link from 'next/link'
import { useRouter } from 'next/navigation'
import React from 'react'

import { Button } from '@/legacy-src/components/ui/button'
import { cn } from '@/legacy-src/lib/utils'

import type { IconBaseType } from '../../types/ComponentTypes'
import Icon from '../icons/Icon'

export type BackButtonPropsType = {
  linkAs?: string
  link?: Url
  text: string
  onClick?: () => void
  navigateBack?: boolean
} & IconBaseType

const BackButton = ({
  link,
  linkAs,
  text,
  color,
  size = 'sm',
  icon,
  onClick,
  navigateBack = false,
}: BackButtonPropsType) => {
  const router = useRouter()

  const handleRedirect = () => {
    if (typeof onClick === 'function') {
      onClick()
    } else if (navigateBack) {
      router.back()
    }
  }
  const renderButton = (onClick?: () => void) => (
    <Button className={cn('back-button', { [`back-button--${size}`]: !!size })} variant="inline" onClick={onClick}>
      {icon && <Icon className="back-button__back-icon" color={color} icon={icon} size={size} />}
      <span className={cn('back-button__text', { [`back-button__text--${size}`]: !!size })}>{text}</span>
    </Button>
  )

  return link ? (
    <Link href={link} as={linkAs || link}>
      {renderButton()}
    </Link>
  ) : (
    renderButton(handleRedirect)
  )
}

export default BackButton
